import React from "react";

export const PlayIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 1V19L17.4 10L3 1Z" fill="currentColor" />
    </svg>
  );
};
